import React, { useState } from "react";
import {
  Box,
  Text,
  Badge,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  VStack,
  Image,
  HStack,
  Spinner,
} from "@chakra-ui/react";
import { FiMoreVertical, FiTrash2, FiRotateCcw, FiEdit } from "react-icons/fi";
import chatBotIcon from "../../assets/waveflowadmin/jam_play.svg";
import deployIcon from "../../assets/waveflowadmin/clarity_deploy-line.svg";
import downloadjson from "../../assets/waveflowadmin/bytesize_download.svg";
import redirecticon from "../../assets/waveflowadmin/f7_arrow-up.svg";
import calenderIcon from "../../assets/waveflowadmin/mdi_calendar.svg";
import { truncateText } from "../../utiils/truncateText";
import DownLoadWorkFlowAdmin from "../../components/DownLoadBtn/DownLoadWorkFlowAdmin";
import { editWorkflowPost, GettingWorkFlowId } from "../../allApi/api";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setwaveflowagentsData } from "../../redux/reducer/waveFlow";

const WorkflowCard = (props) => {
  const [downloadLoader, setdownloadLoader] = useState(false);
  const [editloader, seteditloader] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const downloadJSON = async (workflowId) => {
    setdownloadLoader(true);
    try {
      const historyWorkflow = await GettingWorkFlowId({
        session_id: workflowId,
      });
      const data = historyWorkflow?.agents || [];
      const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
        JSON.stringify(data, null, 2)
      )}`;

      const link = document.createElement("a");
      link.href = jsonString;
      link.download = "workflow.json";
      link.click();
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setdownloadLoader(false);
    }
  };
  const handleEditWorkflow = async (sessionId) => {
    seteditloader(true);
    try {
      const data = await editWorkflowPost(sessionId);

      dispatch(setwaveflowagentsData(data));

      navigate("/", {
        state: {
          openWorkflows: true,
          workflowData: data,
        },
      });
    } catch (error) {
      console.error("Failed to edit workflow:", error);
    } finally {
      seteditloader(false);
    }
  };
  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      p={4}
      border={"1px solid "}
      borderColor={"gray.200"}
      position="relative"
      bg="white"
      w={"100%"}
    >
      {/* Header Section */}
      <Flex justify="space-between" align="start">
        <Box>
          <Text fontSize="lg" color={"#343839"} fontWeight="bold">
            {truncateText(props?.workflow_name, 14)}
          </Text>
          <Badge
            color={"#5856D6"}
            bg={"rgba(88, 86, 214, 0.15)"}
            borderRadius="full"
            px={4}
            py={1}
            fontSize={"xs"}
          >
            {props?.status}
          </Badge>
        </Box>

        {/* 3 Dots Menu */}
        {editloader ? (
          <Spinner size="sm" color="blue.500" />
        ) : (
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Options"
              icon={<FiMoreVertical />}
              variant="ghost"
              size="sm"
            />
            <MenuList>
              <MenuItem
                icon={<FiRotateCcw />}
                onClick={() => props?.chatHistoryHandle(props?.session_id)}
              >
                Chat History
              </MenuItem>
              <MenuItem
                icon={<FiEdit />}
                onClick={() => handleEditWorkflow(props?.session_id)}
              >
                Edit
              </MenuItem>
              <MenuItem
                icon={<FiTrash2 />}
                color="red.500"
                onClick={() => props?.playdeleteHandle(props?.session_id)}
              >
                Delete
              </MenuItem>
            </MenuList>
          </Menu>
        )}
      </Flex>

      {/* Description */}
      <Text fontSize="sm" mt={3} color="gray.600">
        {props?.workflow_desc || "No description provided."}
      </Text>

      {/* Action Buttons */}
      <Flex
        border="1px solid"
        borderColor="gray.300"
        borderRadius="md"
        overflow="hidden"
        mt={4}
      >
        <Button
          flex="1"
          variant="ghost"
          borderRadius="0"
          borderRight="1px solid"
          borderColor="#E9EAEB"
          p={6}
          onClick={() => props?.playHistoryHandle(props?.session_id)}
        >
          <VStack spacing={1}>
            <Image src={chatBotIcon} alt="chatbot" />
            <Text fontSize="8px">Run Chatbot</Text>
          </VStack>
        </Button>

        <Button
          flex="1"
          variant="ghost"
          borderRadius="0"
          borderRight="1px solid"
          borderColor="#E9EAEB"
          p={6}
          isDisabled={props?.deployed_details?.live_url ? true : false}
          onClick={() =>
            props?.handleDeploy(
              props?.workflow_name,
              props?.workflow_desc,
              props?.session_id
            )
          }
        >
          <VStack spacing={1}>
            <Image src={deployIcon} alt="deploy" />
            <Text fontSize="8px">Deploy</Text>
          </VStack>
        </Button>

        <Button
          onClick={() => downloadJSON(props.session_id)}
          flex="1"
          variant="ghost"
          borderRadius="0"
          p={6}
        >
          <VStack spacing={1}>
            {downloadLoader ? (
              <Spinner size="sm" />
            ) : (
              <Image src={downloadjson} alt="json" />
            )}

            <Text fontSize="8px">Export Conf JSON</Text>
          </VStack>
        </Button>
      </Flex>

      <Flex
        mt={4}
        justify="space-between"
        align="center"
        fontSize="sm"
        bordertop={"1px solid black"}
      >
        <HStack spacing="4px">
          <Image src={calenderIcon} alt="calendar" boxSize="14px" />
          <Text
            fontSize="xs"
            fontWeight={400}
            color="rgba(108, 114, 117, 0.50)"
          >
            {props?.date}
          </Text>
        </HStack>
        {props?.deployed_details?.live_url && (
          <Button
            as="a"
            href={props?.deployed_details?.live_url}
            target="_blank"
            rel="noopener noreferrer"
            size="xs"
            colorScheme="blue"
            variant="link"
            rightIcon={
              <Image src={redirecticon} alt="redirect" boxSize="14px" />
            }
            iconSpacing="4px"
          >
            <Text as="span" textDecoration="underline">
              View App
            </Text>
          </Button>
        )}
      </Flex>
    </Box>
  );
};

export default WorkflowCard;
